<template>
	<div class="row">
		<div class="col-md-12">
			<incident-reports
				@reload="reload"
				:user="user"
				:isAuth="isAuth"
				:data="item">
			</incident-reports>
		</div>
	</div>
</template>

<script>
	import IncidentReports from './../components/incidentReports/layout/IncidentReports.vue'

	export default {
		props: ['user', 'isAuth', 'item'],
		components: {
			'incident-reports': IncidentReports,
		},
		data () {
			return {
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
			},
			reload() {
				this.$emit('reload')
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/projects/projects/views/Incidents.vue